var _defs, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGe = function SvgGe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 200"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "ge_svg__c"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "ge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-109 104a104 104 0 0 0 0-208h218a104 104 0 0 0 0 208z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ge_svg__b",
    d: "M-55 74a55 55 0 0 1 110 0V-74a55 55 0 0 1-110 0z",
    clipPath: "url(#ge_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ge_svg__b",
    transform: "rotate(90)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h300v200H0z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 0v80H0v40h130v80h40v-80h130V80H170V0z",
    style: {
      fill: "red"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ge_svg__c",
    fill: "red",
    transform: "translate(64.45 39.45)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ge_svg__c",
    fill: "red",
    transform: "translate(235.55 160.55)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ge_svg__c",
    fill: "red",
    transform: "translate(235.55 39.45)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ge_svg__c",
    fill: "red",
    transform: "translate(64.45 160.55)"
  })));
};
export default SvgGe;